/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminBlockExercise,
  AdminBlockExerciseCreate,
  PatchedAdminBlockExercise
} from '.././model';

import adminV1OrganizationsBlocksExercisesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBlocksExercisesUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBlocksExercisesPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBlocksExercisesDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksExercisesCreate = (
    organizationId: number,
    adminBlockExerciseCreate: NonReadonly<AdminBlockExerciseCreate>,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksExercisesCreateMutator<AdminBlockExerciseCreate>>,) => {
      return adminV1OrganizationsBlocksExercisesCreateMutator<AdminBlockExerciseCreate>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks_exercises/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminBlockExerciseCreate
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksExercisesUpdate = (
    organizationId: number,
    id: number,
    adminBlockExercise: NonReadonly<AdminBlockExercise>,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksExercisesUpdateMutator<AdminBlockExercise>>,) => {
      return adminV1OrganizationsBlocksExercisesUpdateMutator<AdminBlockExercise>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks_exercises/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminBlockExercise
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksExercisesPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminBlockExercise: NonReadonly<PatchedAdminBlockExercise>,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksExercisesPartialUpdateMutator<AdminBlockExercise>>,) => {
      return adminV1OrganizationsBlocksExercisesPartialUpdateMutator<AdminBlockExercise>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks_exercises/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminBlockExercise
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsBlocksExercisesDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsBlocksExercisesDestroyMutator<void>>,) => {
      return adminV1OrganizationsBlocksExercisesDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/blocks_exercises/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsBlocksExercisesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksExercisesCreate>>>
export type AdminV1OrganizationsBlocksExercisesUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksExercisesUpdate>>>
export type AdminV1OrganizationsBlocksExercisesPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksExercisesPartialUpdate>>>
export type AdminV1OrganizationsBlocksExercisesDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBlocksExercisesDestroy>>>
